export default "__VITE_ASSET__BY8tSNf7__"